import { useState } from "react";
import GroupOfButtons from "../../Molecules/GroupOfButtons/GroupOfButtons";
import './ManageCampaigns.scss';
import HeaderTitle from "../../Molecules/HeaderTitle/HeaderTitle";
import CampainsTable from "../../Molecules/CampainsTable/CampainsTable";

const ManageCampaigns = () => {
  const [formsHandler, setFormsHandler] = useState({
    showForm1: true,
    showForm2: false,
    showForm3: false,
  });

  return (
    <div className="nd-grid rows-gap-3">

      <HeaderTitle headerText="Gestión de campañas" />

      <GroupOfButtons
        content={{
          first: "Activas",
          second: "Inactivas",
          third: "En borrador",
        }}
        formsHandler={formsHandler}
        setFormsHandler={setFormsHandler}
      />

        {formsHandler.showForm1 &&
          <CampainsTable active />
        }
        {formsHandler.showForm2 && 
          <CampainsTable inactive />
        }
        {formsHandler.showForm3 && 
          <CampainsTable draft />
        }
      </div>
  );
};

export default ManageCampaigns;
